export type DataType = {
    [key: string]: string | string[];
}

export enum DataGroup {
    NODE = 'node',
    LINK = 'link'
}

export type NodeType = DataType & {
    id: string;
}

export type LinkType = DataType & {
    source: string;
    target: string;
}

export type SharedDataType = {
    source: string;
    subType: string;
    rangeMin?: number;
    rangeMax?: number;
    rangeField?: string;
}

export type SubTypeColor = { subType: string, color: string, count: number };

export const NODE_SOURCE_LIST_NAME = "sourceList";